module.exports = __webpack_public_path__ + "flyInLeft.gif";